import { observer } from 'mobx-react';
import React, { useCallback } from 'react';
import Skeleton from 'react-loading-skeleton';
import exclusionsStore from '../../store/exclusionsStore';
import { IExclusion } from '../../types/exclusions';
import { SCREENS } from 'src/constants/screens';
import { localeStore } from 'src/mobx/localesStore';
import { history } from 'src/services/history';
import { TBooleanInNumber } from 'src/types/main';
import { confirmDelete } from 'src/utils/modalConfirmations';
import Switcher from 'src/view/components/Controls/Switcher/Switcer';
import DeleteRestoreBlock from 'src/view/components/DeleteRestoreBlock/DeleteRestoreBlock';
import Text, { TEXT } from 'src/view/components/Text/Text';
import './style.scss';

interface IProps {
  exclusion?: IExclusion;
}

const ExclusionsListRow: React.FC<IProps> = observer((props: IProps): JSX.Element => {
  const editExclusion = () => {
    if (!props.exclusion) return;
    history.push(SCREENS.EXCLUSIONS_EDIT(props.exclusion.id));
  };

  const deleteExclusion = () => {
    confirmDelete({
      message: localeStore.t('confirm_deleting_exclusion'),
      onConfirm: () => props.exclusion && exclusionsStore.deleteExclusion(props.exclusion.id),
    });
  };

  const changeStatus = useCallback(
    (status: TBooleanInNumber) => {
      if (!props.exclusion) return;
      exclusionsStore.changeStatus(props.exclusion.id, status);
    },
    [props.exclusion]
  );

  return (
    <li className="exclusions-list-row d-flex full-width">
      <div className="d-flex flex-row align-items-center w-70">
        {props.exclusion ? <Text type={TEXT.LIST_ROW} text={props.exclusion.name} /> : <Skeleton width={250} height={19.2} />}
      </div>
      <div className="d-flex flex-row align-items-center w-30 justify-content-between">
        {/* availability switcher */}
        {!props.exclusion ? (
          <Skeleton width={50} height={30} style={{ borderRadius: 30 }} />
        ) : (
          <Switcher disabled={exclusionsStore.isLoading} status={props.exclusion.status} onChange={changeStatus} />
        )}
        <DeleteRestoreBlock skeleton={!props.exclusion} disabled={exclusionsStore.isLoading} onDelete={deleteExclusion} />
      </div>
      <div className="exclusions-list-row__btn-edit" onClick={editExclusion} />
    </li>
  );
});

export default ExclusionsListRow;
